































































import Vue from 'vue';

import checkInstalled from '@/utils/checkInstalled';
import { StorageKey, getItem, setItem } from '@/utils/storage';

export default Vue.extend({
  name: 'Drawer',
  props: {
    onFileOpen: Function,
    onFileSave: Function,
    onFileSaveAs: Function,
    onAutoSaveChange: Function,
  },
  data: () => ({
    isInstalled: checkInstalled(),
    shouldAutoSave: getItem<boolean>(StorageKey.shouldAutoSave),
  }),
  methods: {
    handleShouldAutoSaveChange() {
      setItem(StorageKey.shouldAutoSave, this.shouldAutoSave);
      this.onAutoSaveChange && this.onAutoSaveChange(this.shouldAutoSave);
    },
  },
});
